<script setup lang="ts">
import { InputText, Message, ToggleButton, ScrollPanel, Button } from 'primevue';
import { storeToRefs } from 'pinia';
import { useTranslations } from 'shared/translations/composables/useTranslations';
import { useKeybindStore } from 'shared/vehicles/stores/keybindStore';


const translation = useTranslations();
const keybindStore = useKeybindStore();
const { formData } = storeToRefs(keybindStore);

</script>

<template>
  <div class="wrapper">
    <div class="header">
      <div class="lockDiv">
        <ToggleButton
          v-model="keybindStore.isLocked"
          :onLabel="translation.generic.locked"
          :offLabel="translation.generic.unlocked"
          onIcon="pi pi-lock"
          offIcon="pi pi-lock-open"
          class="my-2"
          fluid
        />
      </div>

      <h1 class="text-xl font-medium">{{ translation.keybinds.action }}</h1>
      <h1 class="text-xl font-medium">{{ translation.keybinds.keybind }}</h1>
    </div>

    <ScrollPanel class="scroll-panel">
      <div
        class="flex keyboard-shortcuts-form items-center"
        v-for="(item, index) in formData"
        :key="item.action"
      >
        <Message severity="secondary">
          {{ item.keybind.actionText }}
        </Message>

        <div class="flex">
          <div
            class="field w-full"
            :class="{ changed: formData[index]!.changed }"
          >
            <InputText
              v-model="formData[index]!.keybind.keyText"
              @keydown="(e) => keybindStore.editKeybind(index, e)"
              fluid
            />
          </div>
        </div>
      </div>
    </ScrollPanel>

    <footer class="actions">
      <Button
        severity="secondary"
        outlined
        :label="translation.generic.resetToDefault"
        @click="keybindStore.resetToDefault"
      />
    </footer>
  </div>
</template>

<style scoped>
.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  display: grid;
  column-gap: .5rem;
  grid-template-columns: repeat(2, 1fr);
  flex-shrink: 0;
}

.lockDiv {
  margin: 2px;
  grid-column: 1 / 3;
}

.scroll-panel {
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.keyboard-shortcuts-form {
  display: grid;
  column-gap: .5rem;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 1rem;
}

.actions {
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
  padding: 1rem;
  flex-shrink: 0;
}
</style>
